import React from 'react'
import EnthNav from '../../EnthNav/EnthNav'
import FooterFixed from "../../FooterFixed/FooterFixed";

const About = () => {
  return (
    <div>
    <EnthNav/>
    <div class="container">
    <div class="row">
        <div class="col-lg-3 col-md-2 col-2">
          
        </div>
        <div class="col-lg-6 col-md-8 col-8" >

        <h3 className='p-4'>About</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-2 col-2">
         
        </div>
        <div class="col-lg-6 col-md-8 col-8" >

          <p class="text-justify"> 
Enth&trade; provides tools to search, access, organize and integrate data.  Our roots go back to the 1990’s, licensing patented SQL and analytics technology to Teradata.  Our technology is based on relational mathematics, which we use to select data sources and tables used to generate the code required to access the source.  We are intrigued to see the industry rush to use AI to reproduce this technology.  We had thought and still think tools to generate the code to access data was solved…decades ago…with a much lighter touch.
</p><p class="text-justify">
In the mid-2000’s we formed Enth, targeting search of structured data sources.  We quickly realized we were focused on solving the wrong problem.  SQL generation was not a transformative technology, it turns out managing metadata (data about data) in real time is the transformative technology enabling the next generation of data access.
</p><p class="text-justify">
What is Dynamic Metadata&trade;?  Imagine presenting a data source to a service, the source may have a single table or 100’s, the service identifies and documents the physical attributes (column names, data types, size…), the relationships (joins) within the source, then looks for patterns within the source (Time, Geography, Taxonomic…) and finally, virtually connects the new source to all the other sources available in the universe.  The universe referred to here is Enth, the process is Synchronize&trade;and the output is Dynamic Metadata.  
</p><p class="text-justify">
Enth holds no actual data.  Enth is Dynamic Metadata repository, which allows our members to create unique, virtual collections of metadata.  Put more simply, plug your data into Enth and Enth will generate a virtual universe containing your data and everything relevant to your data!  Feel free to query or search within or across the universe.
</p><p class="text-justify">
Enth as a Metadata-as-a-Service&trade; (MaaS&trade;) company, a proprietary AI for generating virtualized data universes.  A public version of Enth is available at no cost, at www.enth.com.  Enth is also available through various subscriptions levels.
          </p> 
        </div>
      </div>
    </div>     
    <FooterFixed/>  
   </div>
  )
}

export default About